




















# import settings from '@/settings'
import t from '@/utils/tools'
import Menus from '@/components/menus'

export default {
    name: 'company_interviews'

    components: { Menus }

    watch:
        '$route': (route_to, route_from)->
            # console.log "WATCH ROUTE", route_to,
            if route_to.name == 'company_interviews'
                @define_route()

    data: ()->
        interviews_accesses: ['interviews_show','interviews_campaigns_show']
        interviews_routes: ['company_interviews_history','company_interviews_campaigns']

    methods:
        has_access_right: t.has_access_right

        define_route: ()->
            for index, a of @interviews_accesses
                if @has_access_right(a)
                    @$router.push({name:@interviews_routes[index]})
                    .catch (err)-> {}
                    break
        
    beforeMount: ()->
        @define_route()
}

